import { render, staticRenderFns } from "./CreateProjectIssue.vue?vue&type=template&id=0311c11c&scoped=true&"
import script from "./CreateProjectIssue.vue?vue&type=script&lang=js&"
export * from "./CreateProjectIssue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0311c11c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VDialog})
